<script lang="ts">
  import { emojiVariant } from '@centerhealth/fe/stores';
  import { CenterImage } from '@centerhealth/fe/center-kit';
  import { createSourceSet, createSource, ISrcSetData } from '@centerhealth/fe/images';

  //Stats image
  const imageObject: ISrcSetData = {
    sourceUrl: '/assets/images/stats-bg.webp',
    sizes: [
      { width: 800, widthScreen: 0 },
      { width: 600, widthScreen: 390 },
      { width: 600, widthScreen: 575 },
      { width: 1000, widthScreen: 768 },
      { width: 1400, widthScreen: 1000 },
    ],
  };
</script>

<section class="mt-7 md:mt-6 xxl:mt-7 xl:mb-[400px]">
  <div
    class="container mx-auto grid grid-cols-12 gap-4 grid-flow-row grid-rows-2 md:grid-rows-3 xl:grid-rows-1"
  >
    <div class="row-start-1 row-end-2 col-span-12 lg:col-start-1 lg:col-end-6">
      <CenterImage>
        <img
          width="968"
          height="900"
          class="-left-28 object-contain absolute transform scale-150 img-mq-overrides"
          srcset={createSourceSet(imageObject)}
          src={createSource(imageObject.sourceUrl)}
          alt="stats"
          loading="lazy"
        />
      </CenterImage>
    </div>
    <div class="pt-1/4 text-center col-span-12 row-start-2 info-mq-overrides">
      <div>
        <h2>
          {$emojiVariant === 'control' ? '📈' : ''} See how your daily life affects your blood sugar
        </h2>
        <p class="text-base xl:text-lg">
          Search carbs, see your A1C, sync fitness trackers, sleep apps & more to see your blood
          sugar in context
        </p>
      </div>
    </div>
  </div>
</section>

<style lang="postcss">
  img {
    width: 90%;
    max-height: 240px;
    overflow: auto;
  }

  p {
    color: #656b73;
    line-height: 1.3;
    margin-top: 10px;
  }

  @screen md {
    img {
      height: 540px;
      width: 645px;
      max-height: none;
      @apply -left-96 scale-125;
    }
    .info-mq-overrides {
      @apply pt-0 text-left col-start-7;
    }
  }

  @screen lg {
    img {
      @apply -left-80;
    }
    .info-mq-overrides {
      @apply row-start-2;
    }
  }

  @screen xl {
    img {
      height: 600px;
      @apply -left-60;
    }
    .info-mq-overrides {
      @apply col-end-12 row-start-1 mt-[200px];
    }
  }
  @screen xxl {
    img {
      height: 600px;
      @apply -left-36 scale-150;
    }
    .info-mq-overrides {
      @apply col-start-8 col-end-13;
    }
  }
</style>
